import React from "react";
import logo from "../Assets/navbarLogo.webp"
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <div className="footerSection">
        <div className="footerWrapper">
          
            <div className="interiorContactInfo">
            <figure>
                <img src={logo} alt="" />
            </figure>
              <div className="para">
              <p><i class="fa-light fa-phone"></i>+1880 123 456 789</p>
            <p><i class="fa-light fa-envelope"></i>contact@yourmail.com</p>
            <p><i class="fa-light fa-map"></i>1234 Avenue New York, US</p>
              </div>
            <div className="social">
            <div className="socialBtn"><i class="fa-brands fa-facebook-f"></i></div>
            <div className="socialBtn"><i class="fa-brands fa-twitter"></i></div>
             <div className="socialBtn"><i class="fa-brands fa-google"></i></div>
            <div className="socialBtn"><i class="fa-brands fa-instagram insta"></i></div>
            </div>
            </div>

            <div className="groupBlock">
            <div className="footerBlock">
                <h1>Essential Links</h1>
                <ul>
                    <li><NavLink to="/about">About</NavLink></li>
                    <li><NavLink to="/projects">Projects</NavLink></li>
                    <li><a href="/" onClick={(e) => {e.preventDefault()}}>Support</a></li>
                </ul>
            </div>
            <div className="footerBlock ">
                <h1>Services</h1>
                <ul>
                  <li><a href="/" onClick={(e) => {e.preventDefault()}}>Product Design</a></li>
                  <li><a href="/" onClick={(e) => {e.preventDefault()}}>Research</a></li>
                  <li><a href="/" onClick={(e) => {e.preventDefault()}}>Office Management</a></li>
                </ul>
            </div>
            </div>
            <div className="footerBlock lastBlock">
                <h1>Newsletter</h1>
                <div className="details">
                  <p>Lorem ipsum dolor sit amet, consec tetur adipiscing elit.</p>
                  <div className="formgroup">
                    <input type="text" placeholder="info@contact.com" />
                    <i class="fa-light fa-angles-right"></i>
                  </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 by YourCompany.</p>
        </div>
      </div>
    </>
  );
}
